import { FilterOption } from '../../components/_WMS/FilterComponent'
import { eTypeStorage } from '../../enums/eTypeStorage'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'workOrderId',
    label: 'ID Orden de Trabajo',
    type: 'numeric'
  },
  {
    order: 2,
    key: 'workOrderStateId',
    label: 'Estado',
    type: 'precreated',
    canBeRepeated: true
  },
  {
    order: 3,
    key: 'initialCreatedDate',
    label: 'Fecha Creación Desde',
    type: 'date'
  },
  {
    order: 4,
    key: 'finalCreatedDate',
    label: 'Fecha Creación Hasta',
    type: 'date'
  },
  {
    order: 5,
    key: 'initialPromiseDate',
    label: 'Fecha Compromiso Desde',
    type: 'date'
  },
  {
    order: 6,
    key: 'finalPromiseDate',
    label: 'Fecha Compromiso Hasta',
    type: 'date'
  },
  {
    order: 7,
    key: 'sku',
    label: 'SKU',
    type: 'text'
  },
  {
    order: 8,
    key: 'warehouseId',
    label: 'Almacén',
    type: 'precreated'
  },
  {
    order: 9,
    key: 'productOriginId',
    label: 'Marca',
    type: 'precreated',
    filterParams: {
      typeStorageId: [eTypeStorage.Interno, eTypeStorage.Mixto]
    }
  }
]

export const defaultFilters = [
  {
    key: 'workOrderStateId',
    value: 1,
    label: 'Estado',
    displayValue: 'Creada'
  },
  {
    key: 'workOrderStateId',
    value: 2,
    label: 'Estado',
    displayValue: 'Disponible para picking'
  },
  {
    key: 'workOrderStateId',
    value: 3,
    label: 'Estado',
    displayValue: 'En ruta de picking'
  },
  {
    key: 'workOrderStateId',
    value: 4,
    label: 'Estado',
    displayValue: 'En proceso masivo'
  },
  {
    key: 'workOrderStateId',
    value: 5,
    label: 'Estado',
    displayValue: 'Picking finalizado'
  },
  {
    key: 'workOrderStateId',
    value: 6,
    label: 'Estado',
    displayValue: 'En validación'
  },
  {
    key: 'workOrderStateId',
    value: 13,
    label: 'Estado',
    displayValue: 'Disponible para picking externo'
  }
]
